import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
// import Footer from './component/Footer';
import api from './api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getLocalData } from './utils/localStorageHelper';
import { useAuth } from './utils/AuthContext';
import CelebrationOverlay from './utils/CelebrationOverlay';

const UserLogin = () => {
    const { login } = useAuth();
    const [user, setUser] = useState(null);
    const [phone, setPhone] = useState('');
    const [otp, setOtp] = useState('');
    const [otpSent, setOtpSent] = useState(false);
    const [timer, setTimer] = useState(0);
    const [showWelcomePopup, setShowWelcomePopup] = useState(false);
    const [showCelebration, setShowCelebration] = useState(false);
    const timerRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const storedUser = getLocalData('userData');
        setUser(storedUser);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    useEffect(() => {
        return () => { if (timerRef.current) clearInterval(timerRef.current); };
    }, []);

    const startTimer = () => {
        setTimer(30);
        if (timerRef.current) clearInterval(timerRef.current);
        timerRef.current = setInterval(() => {
            setTimer(prev => {
                if (prev <= 1) { clearInterval(timerRef.current); return 0; }
                return prev - 1;
            });
        }, 1000);
    };

    const handleSendOtp = async (e) => {
        e.preventDefault();
        try {
            const response = await api.post('/user/sendOtp', { phone });
            if (response.data.success) {
                setOtpSent(true);
                startTimer();
                toast.success('OTP sent successfully to ' + phone);
            } else {
                toast.error('OTP sending failed: ' + response.data.message);
            }
        } catch (error) {
            if (error.response) toast.error('Server Error: ' + error.response.data.message);
            else if (error.request) toast.error('No response from server. Check API URL.');
            else toast.error('Request Error: ' + error.message);
        }
    };

    const handleResendOtp = async () => {
        try {
            const response = await api.post('/user/sendOtp', { phone });
            if (response.data.success) {
                setOtp('');
                startTimer();
                toast.success('OTP resent successfully to ' + phone);
            } else {
                toast.error('OTP resend failed: ' + response.data.message);
            }
        } catch (error) {
            if (error.response) toast.error('Server Error: ' + error.response.data.message);
            else if (error.request) toast.error('No response from server.');
            else toast.error('Request Error: ' + error.message);
        }
    };

    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        try {
            const res = await api.post('/user/verifyOtp', { phone, otp });
            if (res.data.token) {
                login({ phone, token: res.data.token });
                setShowCelebration(true);
                setTimeout(() => setShowWelcomePopup(true), 800);
            }
        } catch (err) {
            console.error('OTP Verification failed:', err.message);
            toast.error('Invalid OTP. Please try again.');
        }
    };

    const handleCelebrationDone = () => setShowCelebration(false);

    const handleWelcomeOk = () => {
        setShowWelcomePopup(false);
        navigate('/');
    };

    return (
        <>
            {showCelebration && <CelebrationOverlay onDone={handleCelebrationDone} />}

            <main className="main__content_wrapper">
                <div
                    className="login__section section--padding"
                    style={{
                        backgroundImage: 'url("assets/img/bk1.png")',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                    }}
                >
                    <div className="container">
                        <form onSubmit={otpSent ? handleVerifyOtp : handleSendOtp}>
                            <div className="login__section--inner">
                                <div className="row row-cols-md-2 row-cols-1">
                                    <div className="col" style={{ margin: '0 auto' }}>
                                        <div className="account__login">
                                            <div className="account__login--header mb-25">
                                                <h2 className="account__login--header__title h3 mb-10">Login</h2>
                                                <p className="account__login--header__desc">Enter your phone number to login.</p>
                                            </div>
                                            <div className="account__login--inner">

                                                <input
                                                    className="account__login--input"
                                                    placeholder="Enter Phone Number"
                                                    type="tel"
                                                    value={phone}
                                                    onChange={(e) => setPhone(e.target.value)}
                                                    required
                                                />

                                                {otpSent && (
                                                    <input
                                                        className="account__login--input mt-3"
                                                        placeholder="Enter OTP"
                                                        type="text"
                                                        value={otp}
                                                        onChange={(e) => setOtp(e.target.value)}
                                                        required
                                                    />
                                                )}

                                                <button className="account__login--btn primary__btn mt-3" type="submit">
                                                    {otpSent ? 'Verify OTP' : 'Send OTP'}
                                                </button>

                                                {otpSent && (
                                                    <div className="mt-3" style={{ fontSize: '14px', color: '#555' }}>
                                                        {timer > 0 ? (
                                                            <p style={{ margin: 0 }}>
                                                                Resend OTP in{' '}
                                                                <span style={{ fontWeight: 'bold', color: '#e53935' }}>
                                                                    0:{timer.toString().padStart(2, '0')}
                                                                </span>
                                                            </p>
                                                        ) : (
                                                            <button
                                                                type="button"
                                                                onClick={handleResendOtp}
                                                                style={{
                                                                    background: 'none',
                                                                    border: 'none',
                                                                    color: '#1a73e8',
                                                                    cursor: 'pointer',
                                                                    padding: 0,
                                                                    fontSize: '14px',
                                                                    fontWeight: '600',
                                                                    textDecoration: 'underline',
                                                                }}
                                                            >
                                                                Resend OTP
                                                            </button>
                                                        )}
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <ToastContainer position="top-center" autoClose={3000} />
                    </div>
                </div>

            </main>

            {showWelcomePopup && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0, left: 0, right: 0, bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.55)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 100000,
                        animation: 'backdropIn 0.3s ease',
                    }}
                >
                    <div
                        style={{
                            backgroundColor: '#fff',
                            borderRadius: '16px',
                            padding: '44px 36px 36px',
                            maxWidth: '380px',
                            width: '90%',
                            textAlign: 'center',
                            boxShadow: '0 24px 64px rgba(0,0,0,0.25)',
                            animation: 'popupBounce 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)',
                        }}
                    >
                        <div style={{ fontSize: '48px', marginBottom: '12px', lineHeight: 1, animation: 'wiggle 0.6s ease 0.3s both' }}>
                            🎉
                        </div>
                        <h2 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '8px', color: '#1a1a1a', letterSpacing: '-0.3px' }}>
                            Welcome to Overay!
                        </h2>
                        <p style={{ fontSize: '15px', color: '#666', marginBottom: '28px', lineHeight: 1.5 }}>
                            You have successfully logged in. 🥳
                        </p>
                        <button
                            onClick={handleWelcomeOk}
                            style={{
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '10px',
                                padding: '13px 52px',
                                fontSize: '15px',
                                fontWeight: '700',
                                cursor: 'pointer',
                                transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                                boxShadow: '0 4px 15px rgba(102,126,234,0.4)',
                                letterSpacing: '0.3px',
                            }}
                            onMouseEnter={e => {
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = '0 8px 24px rgba(102,126,234,0.5)';
                            }}
                            onMouseLeave={e => {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 4px 15px rgba(102,126,234,0.4)';
                            }}
                        >
                            OK
                        </button>
                        <style>{`
                            @keyframes popupBounce {
                                from { opacity: 0; transform: scale(0.6) translateY(40px); }
                                to   { opacity: 1; transform: scale(1) translateY(0); }
                            }
                            @keyframes backdropIn {
                                from { opacity: 0; }
                                to   { opacity: 1; }
                            }
                            @keyframes wiggle {
                                0%   { transform: rotate(0deg) scale(0.5); }
                                30%  { transform: rotate(-15deg) scale(1.2); }
                                60%  { transform: rotate(10deg) scale(1.0); }
                                80%  { transform: rotate(-5deg) scale(1.05); }
                                100% { transform: rotate(0deg) scale(1); }
                            }
                        `}</style>
                    </div>
                </div>
            )}


            <button id="scroll__top">
                <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512">
                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48"
                        d="M112 244l144-144 144 144M256 120v292" />
                </svg>
            </button>
        </>
    );
};

export default UserLogin;